type DrawerContentProps = { children: React.ReactNode };

const DrawerContent = ({ children }: DrawerContentProps) => {
	return (
		<div aria-hidden="true" className={`vtex-minicart-2-x-drawerContent overflow-y-auto`} style={{ height: '100%' }}>
			{children}
		</div>
	);
};

export default DrawerContent;
